module.exports = "fragment MarketingURLFragment on MarketingURL {\n  __typename\n  id\n  title\n  url\n}\n"